<template>
  <button
    v-bind="$attrs"
    class="pseudo-link"
    :class="{ _mobile: isMobile }"
    v-on="$listeners"
  >
    <slot></slot>
  </button>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import { checkMobile } from '@/utils/deviceCheck';

export default defineComponent({
  name: 'PseudoLink',
  setup() {
    const isMobile = checkMobile();

    return {
      isMobile,
    };
  },
});
</script>

<style lang="less">
.pseudo-link {
  .button-reset();
  .link();

  border-bottom: 1px dashed currentColor;
  transition: border-bottom-color @A;

  &:hover:not(._mobile),
  &._tap {
    border-bottom-color: transparent;
  }
}
</style>
